import { injectIntl } from 'react-intl';
import React, { createRef, useRef } from 'react'
import Translation from '../global/Translation'

import Lightbox from 'react-image-lightbox'
import { copy } from '../../helpers'
import { connect } from 'react-redux'
import Spinner from '../global/Spinner'
import { canViewLotId } from '../../store/products/reducers'
import { fetchProduct } from '../../store/products/actions'
import {getCurrentProductLots, getBundlesRejectionCodes} from '../../store/lots/reducers'
import { goBack } from 'react-router-redux'
import {addCartLineBundle, addCartLineLot} from "../../store/cart/actions";
import DisplayOutletIndicator from "../catalog/rectangleResult/displays/DisplayOutletIndicator";
import {getIsAdding, isSuccessfullyAddedToCart} from "../../store/cart/reducers";
import {canViewAllLots, getSelectedCenter, isMexico, isPeruCenter} from "../../store/centers/reducers";
import {getLastSelectedProduct} from "../../store/selected-objects/reducers";
import ProductDisplayName from '../global/ProductDisplayName'
import { rejectionCodeMap, getBundleRejectionCode } from '../lots/utils';
import Typography from '../design-system/foundations/typography/Typography'
import PnDisplayPrice from '../natural-stone/display-prices/PnDisplayPrice'
import Separator from '../design-system/foundations/separator/Separator'
import styles from '../design-system/moleculars/document-link/style/document_link_style.module.scss'
import Icon from '../design-system/foundations/icon/Icon'
import InputNumber from '../design-system/moleculars/input-number/InputNumber'
import Button from '../design-system/basics/button/Button'


const mapStateToProps = (state, ownProps) => {
    return {
        // product: byProductId(state, ownProps.productId),
        productLots: getCurrentProductLots(state),
        isSuccessfullyAddedToCart: isSuccessfullyAddedToCart(state),
        isAddingToCart: getIsAdding(state),
        canViewAllLots: canViewAllLots(state),
        lastSelectedProduct: getLastSelectedProduct(state),
        bundlesRejectionCodes: getBundlesRejectionCodes(state),
        canViewLotId: canViewLotId(state),
        selectedCenterId: getSelectedCenter(state),
        isMexico: isMexico(state),
        isPeruCenter: isPeruCenter(state)
    }
}
const mapDispatchToProps = dispatch => {
    return {
        fetchProduct: productId => {
            dispatch(fetchProduct(productId))
        },
        goBack: () => {dispatch(goBack())},
        buyLot: (productId, lotId, centerId, extra = null, supplierCenterId = null) => {
            dispatch(addCartLineLot(productId, lotId, centerId, extra, supplierCenterId))
        },
        buyBundle: (productId, bundleId, lotId, qty, centerId, extra = null, supplierCenterId = null) => {
            dispatch(addCartLineBundle(productId, bundleId, lotId, qty, centerId, extra, supplierCenterId))
        },
        onLoadProductDetail: product => {
            dispatch({ type: 'PRODUCT_DETAIL_VISIT', product })
        },
    }
}


class LotImageViewer extends React.Component {
    constructor(props) {
        super(props)

        props.fetchProduct(this.props.productId)

        this.state = {
            photoIndex: this.getIndex(),
            quantity: 1,
            addedLots: {},
            isAddingToCart: false,
            expand: false,
        }

        this.closeWindow = this.closeWindow.bind(this)
        this.copyLink = this.copyLink.bind(this)
        this.lightbox = createRef();
    }

    componentDidMount() {
        document.body.style.overflow = 'hidden'
        if (this.props.lastSelectedProduct) {
            this.props.onLoadProductDetail(this.props.lastSelectedProduct)
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto'
    }

    componentDidUpdate(prevProps) {
        if (this.state.isAddingToCart && prevProps.isAddingToCart && !this.props.isAddingToCart) {
            this.setState({isAddingToCart: false})
            if (this.props.isSuccessfullyAddedToCart) this.closeWindow()
        }
    }

    getIndex = () => {
        return Math.max(0 , this.props.productLots.findIndex(b => b.lot_id === this.props.lotId))
    }

    closeWindow() {
        this.props.goBack()
    }

    copyLink() {
        copy(global.location.href)
    }

    setQuantity = (quantity) => {
        this.setState({quantity: quantity})
    }

    addToCart = (currentLot) => {
        this.setState({ isAddingToCart: true })

        const {
            productId,
            selectedCenterId,
            buyLot,
            buyBundle,
            lastSelectedProduct,
            canViewLotId
        } = this.props

        const isBundle = currentLot && currentLot.bundleId ? true : false
        const visibleLotId = canViewLotId && currentLot && currentLot.lot_id ? currentLot.lot_id : null

        let extra = {}
        let supplierCenterId = null

        if (lastSelectedProduct) {
            if (lastSelectedProduct.extra) {
                extra = lastSelectedProduct.extra
            }
            if (lastSelectedProduct.centerId) {
                supplierCenterId = lastSelectedProduct.centerId
            }
        }

        if (isBundle) {
            buyBundle(
                productId,
                currentLot.bundleId,
                visibleLotId,
                this.state.quantity,
                selectedCenterId,
                extra,
                supplierCenterId
            )
        } else if (currentLot && currentLot.lot_id) {
            buyLot(
                productId,
                currentLot.lot_id,
                selectedCenterId,
                extra,
                supplierCenterId
            )
        }
    }

    getMeasure = (field, current_lot, isSurface) => {
        let localeField = field + '_' + this.props.unit
        if (isSurface) localeField += '2'
        return current_lot[localeField]
    }

    render() {
        const { isAdmin, productId, productLots, outlet, impersonatedBy, canViewAllLots, bundlesRejectionCodes, isMexico, isPeruCenter } = this.props
        const { photoIndex } = this.state;
        const prevIndex = (photoIndex + productLots.length - 1) % productLots.length
        const nextIndex = (photoIndex + 1) % productLots.length
        const currentLot = productLots && productLots.length && productLots[photoIndex]

        // console.log('LOT VIEWER currentLot' , currentLot)
        if (!currentLot) return null

        const width = this.getMeasure('width', currentLot)
        const length = this.getMeasure('length', currentLot)
        const surface = this.getMeasure('qty', currentLot, true)
        const isBundle = currentLot.bundleId && true

        const addedLots = this.state.addedLots[this.state.photoIndex] ? this.state.addedLots[this.state.photoIndex] : 0;
        const maxCount = currentLot && (currentLot.count - addedLots)

        const bundleRejectionCode = isBundle ? getBundleRejectionCode(currentLot, bundlesRejectionCodes) : currentLot.rejectionCode



        return (
            <section id="section-lots-viewer">
                <div className="carousel">
                    {currentLot && !this.state.isAddingToCart ? (
                        <div className="lot-viewer-back">
                            <Lightbox
                                ref={this.lightbox}
                                mainSrc={currentLot.image}
                                // mainSrcThumbnail={currentLot.thumb}
                                // prevSrcThumbnail={productLots[prevIndex].thumb}
                                // nextSrcThumbnail={productLots[nextIndex].thumb}
                                prevSrc={productLots[prevIndex].image}
                                nextSrc={productLots[nextIndex].image}
                                onCloseRequest={this.closeWindow}
                                clickOutsideToClose={false}
                                wrapperClassName={'carousel-custom lot-viewer-wrapper'}
                                onMovePrevRequest={() =>
                                    this.setState({
                                        photoIndex: (photoIndex + productLots.length - 1) % productLots.length
                                    })
                                }
                                onMoveNextRequest={() =>
                                    this.setState({
                                        photoIndex: (photoIndex + 1) % productLots.length
                                    })
                                }
                                toolbarButtons={[
                                    <div className="expand-button"
                                         onClick={() => {
                                             this.setState({expand: !this.state.expand})
                                             // console.log('LIGHT b', this.lightbox.current)
                                             // this.lightbox.current.setState({zoomLevel:0}, () => console.log('LIGHT b', this.lightbox.current.state.zoomLevel))

                                         }}>
                                        <Icon img="expand" size={24} />
                                    </div>
                                ]}
                                reactModalProps={{
                                    portalClassName: `lot-viewer-portal ${this.state.expand ? 'expanded-portal' : ''}`,
                                }}
                                imagePadding={this.state.expand ? 16 : 24}
                                key={'k-' + this.state.expand}
                            />
                            <div className={`lot-viewer-content ${this.state.expand ? 'expanded-content' : ''}`}>
                                <div className='lot-viewer-inner'>
                                    <Typography typeface="title-s-light" white>
                                        <Translation id="material_information" defaultMessage="Material information" />:
                                    </Typography>

                                    <div className='lot-viewer-inner-header'>
                                        <Typography typeface="title-m-medium" white block>
                                            <ProductDisplayName product={this.props.lastSelectedProduct} />
                                        </Typography>

                                        <PnDisplayPrice product={this.props.lastSelectedProduct} outlet={outlet} white />

                                        <div style={{width: 'fit-content'}}>
                                            {outlet && currentLot.qualityOutlet && <DisplayOutletIndicator outletQuality={currentLot.qualityOutlet} />}
                                        </div>
                                    </div>

                                    <div className='lot-viewer-inner-info'>
                                        <div className='lot-viewer-inner-info-data'>

                                            {isBundle &&
                                                <div className="double-cell">
                                                    <Typography typeface="title-s-medium" white>
                                                        <Translation id="bundle_id" defaultMessage="Bundle ID" />:
                                                    </Typography>
                                                    <Typography typeface="title-s-light" white block>
                                                        {currentLot.bundleId}
                                                    </Typography>
                                                </div>
                                            }

                                            {(isAdmin || impersonatedBy || canViewAllLots) && (
                                                <div className="double-cell">
                                                    <Typography typeface="title-s-medium" white>
                                                        <Translation id="lot_id" defaultMessage="Lot ID" />:
                                                    </Typography>
                                                    <Typography typeface="title-s-light" white block>
                                                        {currentLot.lot_id}
                                                    </Typography>
                                                </div>
                                            )}
                                            <div className="double-cell">
                                                <Typography typeface="title-s-medium" white>
                                                    <Translation id="quarryBlock" defaultMessage="Quarry Block" />:
                                                </Typography>
                                                <Typography typeface="title-s-light" white block>
                                                    {currentLot.quarryBlock}
                                                </Typography>
                                            </div>
                                            <div className="double-cell">
                                                <Typography typeface="title-s-medium" white>
                                                    <Translation id="quality" defaultMessage="Quality" />:
                                                </Typography>
                                                <Typography typeface="title-s-light" white block>
                                                    {currentLot.quality}
                                                </Typography>
                                            </div>

                                            {(isAdmin || impersonatedBy || isMexico || isPeruCenter) && (
                                                <div className="double-cell">
                                                    <Typography typeface="title-s-medium" white>
                                                        <Translation id="shade" defaultMessage="Shade" />:
                                                    </Typography>
                                                    <Typography typeface="title-s-light" white block>
                                                        {currentLot.shade}
                                                    </Typography>
                                                </div>
                                            )}

                                            {(isAdmin || impersonatedBy) && (
                                                <div className="double-cell">
                                                    <Typography typeface="title-s-medium" white>
                                                        <Translation id="location" defaultMessage="Location" />:
                                                    </Typography>
                                                    <Typography typeface="title-s-light" white block>
                                                        {currentLot.location}
                                                    </Typography>
                                                </div>
                                            )}

                                            <div className="double-cell">
                                                <Typography typeface="title-s-medium" white>
                                                    {isBundle ? <Translation id="main_size" defaultMessage="Main size" /> : <Translation id="size" defaultMessage="Size" />}:
                                                </Typography>
                                                <Typography typeface="title-s-light" white block>
                                                    {length} x {width} {this.props.unit}
                                                </Typography>
                                            </div>

                                            <div className="double-cell">
                                                <Typography typeface="title-s-medium" white>
                                                    {isBundle ? <Translation id="main_surface" defaultMessage="Main surface" /> : <Translation id="surface" defaultMessage="Surface" />}:
                                                </Typography>
                                                <Typography typeface="title-s-light" white block>
                                                    {surface} {this.props.unit}2
                                                </Typography>
                                            </div>

                                            <div className="double-cell">
                                                <Typography typeface="title-s-medium" white>
                                                    <Translation id="units_available" defaultMessage="Available units" />:
                                                </Typography>
                                                <Typography typeface="title-s-light" white block>
                                                    {currentLot.count}
                                                </Typography>
                                            </div>


                                            <div className="single-cell">
                                                {/* Rejection code when is Bundle, that means when is not only lot */}
                                                {bundleRejectionCode && (
                                                    <div>
                                                        <Typography typeface="title-s-medium" white>
                                                            <Translation id="material_status_information" defaultMessage="Material status information" />:
                                                        </Typography>
                                                        <Typography typeface="title-s-light" white block>
                                                            {rejectionCodeMap[bundleRejectionCode]}
                                                        </Typography>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className='lot-viewer-inner-info-download'>
                                            <Separator secondary />
                                            <a href={process.env.REACT_APP_API_HOST + '/helper/download-url/?url=' + encodeURIComponent(currentLot.image)}
                                               gtm-label={`view-item_button_download-image--${this.props.lastSelectedProduct.displayName}`}
                                            >
                                                <Icon className={`${styles['link-icon']}`} size={24} img="download" white/>
                                                <Typography typeface="body-s-light" white>
                                                    <Translation id="download_image" defaultMessage="Download image" />
                                                </Typography>
                                            </a>
                                        </div>

                                    </div>
                                    <div className="lot-viewer-inner-footer">
                                        <Separator secondary />

                                        {this.props.lastSelectedProduct && !this.props.lastSelectedProduct.fromMall && !isAdmin && (
                                            <div className="lot-viewer-input">
                                                <InputNumber key={currentLot.lot_id} max={maxCount} min={1} valueDefault={1} onChangeValue={v => this.setQuantity(v)}/>
                                                <Button size-fill
                                                        reverse
                                                        style-dark
                                                        onClick={() => this.addToCart(currentLot)}
                                                        img="shopping_cart"
                                                >
                                                    <Typography typeface="body-m-medium">
                                                        <Translation id="add" defaultMessage="Add" />
                                                    </Typography>
                                                </Button>
                                            </div>
                                        )}
                                    </div>


                                </div>


                            </div>
                        </div>
                    ) : (
                        <Spinner loading={true} />
                    )}
                </div>
            </section>
        )
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(LotImageViewer))